<template>
    <v-container fluid>
        <v-row
            v-if="!addRuleOption && !editRuleOption"
            class="px-6"
        >
            <v-col
                class="mt-4 pb-4 pl-0 add-user-header"
                cols="12"
            >
                Auto-Assign
            </v-col>
            <v-col
                cols="2"
                class="pl-0"
            >
                <v-card
                    class="mx-auto elevation-0"
                    height="auto"
                >
                    <v-list class="auto-assign-left-menu">
                        <v-list-item-group
                            v-model="activeTab"
                            mandatory
                        >
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Auto-Assign Rules</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Auto-Assign Tie Breaking</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-col>
            <v-col
                cols="10"
                class="form-area pt-4"
            >
                <AutoAssignRulesList
                    v-if="activeTab === 0"
                    @show-add-rule-option="addRuleOption=true"
                    @show-edit-rule-option="showEditRuleOption"
                />
                <AutoAssignTieBreaking v-if="activeTab === 1" />
            </v-col>
        </v-row>
        <v-row v-if="addRuleOption">
            <AddAutoAssignRule @hide-add-rule-option="addRuleOption=false" />
        </v-row>
        <v-row v-if="editRuleOption">
            <AddAutoAssignRule
                :row="editRuleRow"
                :edit-mode="true"
                @hide-edit-rule-option="editRuleOption=false"
            />
        </v-row>
    </v-container>
</template>
<script>
import AutoAssignRulesList from './AutoAssignRulesList';
import AutoAssignTieBreaking from './AutoAssignTieBreaking';
import AddAutoAssignRule from './AddAutoAssignRule.vue';

export default {
    name: 'AutoAssignRules',
    components: {
        AutoAssignRulesList,
        AutoAssignTieBreaking,
        AddAutoAssignRule
    },
    data: () => ({
        activeTab: 0,
        addRuleOption: false,
        editRuleOption: false,
        editRuleRow: {}
    }),
    methods: {
        showEditRuleOption(row) {
            this.editRuleRow = row;
            this.editRuleOption = true;
        }
    }
};
</script>

<style>
    .auto-assign-left-menu .v-list-item {
        border-left: 3px #F5F7FA solid;
        color: #7F8592 !important;
        background-color: #F5F7FA;
        margin-bottom: 3px;
    }
    .auto-assign-left-menu .v-list-item.v-item--active {
        border-left: 3px #122448 solid;
        color: #122448 !important;
        background-color: #F0F6FF;
    }
</style>